import { AsyncPipe } from '@angular/common';
import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { BonusStatus } from '@my-account/const';
import { BonusStatusService } from '@my-account/feature';
import { BonusWidgetComponent, SdvorClickOutsideDirective } from '@sdvor/shared/ui/v2';
import { DeviceService } from '@shared/services';
import { BehaviorSubject, filter, Observable, take, tap } from 'rxjs';

@Component({
  selector: 'sd-bonus-status-block',
  templateUrl: './bonus-status-block.component.html',
  styleUrls: ['./bonus-status-block.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AsyncPipe, SdvorClickOutsideDirective, BonusWidgetComponent],
})
export class BonusStatusBlockComponent implements OnInit, AfterViewInit {
  bonusStatus$: Observable<BonusStatus | undefined>;
  isTooltipOpen$ = new BehaviorSubject<boolean>(false);
  progressWidth = 0;
  isDesktopLgUp$: Observable<boolean> = this.deviceService.isDesktopLgUp$;

  constructor(
    private bonusStatusService: BonusStatusService,
    private deviceService: DeviceService,
    private cdr: ChangeDetectorRef,
  ) {}

  ngAfterViewInit(): void {
    this.bonusStatus$.pipe(filter(Boolean), take(1)).subscribe(() => {
      this.cdr.detectChanges();

      const activeBlock = document.getElementById('scrollId');
      if (activeBlock) {
        activeBlock.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      }
    });
  }

  ngOnInit(): void {
    this.bonusStatusService.loadBonusStatus();

    this.bonusStatus$ = this.bonusStatusService.getBonusStatus().pipe(
      filter(Boolean),
      tap((bonusStatus) => {
        // targetLoyaltyAmount это сколько еще нужно набрать, loyaltyAmount текущее
        const totalAmount = bonusStatus.loyaltyAmount.value + bonusStatus.targetLoyaltyAmount?.value || 0;

        this.progressWidth = (bonusStatus.loyaltyAmount.value / totalAmount) * 100;
      }),
    );
  }

  toggleTooltip(): void {
    this.isTooltipOpen$.next(!this.isTooltipOpen$.value);
  }

  closeTooltip(): void {
    this.isTooltipOpen$.next(false);
  }
}
